var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBacteria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.89,41.84a32.53,32.53,0,0,0-26.72,37.4L69.89,139a32.39,32.39,0,1,0,63.91-10.53l-9.73-59.77A32.39,32.39,0,0,0,86.89,41.84ZM94,77.15A12.2,12.2,0,1,1,80,67,12.26,12.26,0,0,1,94,77.15Zm20.64,48.34a2.8,2.8,0,0,1,.92-3.84,2.77,2.77,0,0,1,3.82.92,2.81,2.81,0,0,1-.92,3.85A2.75,2.75,0,0,1,114.61,125.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.4,113.89,87.2,121m36.66-53.83,10-1.1M125.91,45l-7.49,6.65M106.48,31.73l-2.59,9.71M84.33,31l1.42,9.94m-23.91.5,8.38,5.49M53.14,56.44l7.52,6.63M51.38,80l7.1-4m-4.26,26.68,8.65-5M56,122.6l9.92-1.28m-7.09,16.54,9.78,2.06M68,162.35l7.46-6.7M89,175.19l2.53-9.72m37.26,1.08-7-7.15m20.13-10.93-9.77-2.14m11.68-22-9.08,4.21m6.72-19.73-9.94,1m6.08-23.68-9.1,4.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.92,108.91a2.72,2.72,0,0,1-2,3.15,2.49,2.49,0,0,1-2.82-2.26,2.76,2.76,0,0,1,2-3.16A2.51,2.51,0,0,1,105.92,108.91Zm-2.45,34.33a2.73,2.73,0,0,1-2,3.16,2.51,2.51,0,0,1-2.82-2.27,2.72,2.72,0,0,1,2-3.15A2.51,2.51,0,0,1,103.47,143.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.76,166.1s3.12,26.76,28.91,23.16,11.57-34.46,35.94-38M111.74,72.85l-5.21,10.89"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacteria);
export default __webpack_public_path__ + "static/media/BACTERIA.3ceca0735e2ee012e5ce80e0e0fd6d0f.svg";
export { ForwardRef as ReactComponent };